import hfCache from './hfCache'

/**
 * 随机字符串
 * @param len
 * @returns {string}
 */
let randomString = function (len) {
  len = len || 20
  let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  let maxPos = $chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

function isEmptyObject(obj) {
  return !obj || Object.keys(obj).length == 0;
}

const isCustomize=()=>{
  const companyId= app.$store.getters['auth/token'].companyId,companyIds=['1973'];
  return companyIds.includes(companyId)
}

export {isCustomize}

export default {
  isEmptyObject,
  randomString,
  ...hfCache
}



// WEBPACK FOOTER //
// ./src/utils/utils.js